import React, { Component } from 'react';
import { connect } from 'react-redux';
import { airIndexes } from '../../../lib/variables';
import RangeInputSetter from '../components/RangeInputSetter/RangeInputSetter';
import { ThermostatsActions } from '../../../store/actionCreators';

class RangeSetterContainer extends Component {
  state = {
    switchChecked: this.props.initialTriggerEntities[this.props.airType].isEnabled,
    onAt: this.props.initialTriggerEntities[this.props.airType].onAt,
    rangeMouseDownFlag: false
  };

  componentDidUpdate(prevProps, prevState) {
    const { airType } = this.props;
    if (prevProps.changedTriggerEntities[airType].isEnabled !== this.props.changedTriggerEntities[airType].isEnabled) {
      this.setState({ switchChecked: this.props.changedTriggerEntities[airType].isEnabled });
    }
    if (prevProps.changedTriggerEntities[airType].onAt !== this.props.changedTriggerEntities[airType].onAt) {
      this.setState({ onAt: this.props.changedTriggerEntities[airType].onAt });
    }
  }

  handleSwitchChange = () => {
    const { switchChecked } = this.state;
    const { onToggleSwitch, airType } = this.props;

    onToggleSwitch(airType, !switchChecked);
    ThermostatsActions.convertToInitialValue(false);
  };

  onRangeMouseDown = () => {
    this.setState({ rangeMouseDownFlag: true });
  };

  getRangeStep = () => {
    const { airType } = this.props;

    if (airType === 'co2' || airType === 'voc' || airType === 'voc_v1') {
      return 10;
    }

    return 1;
  };

  onRangeMouseUp = (event, rangeValue) => {
    let airType = this.props.airType;
    if (airType === 'voc_v1') {
      airType = 'voc';
    }
    this.setState({ rangeMouseDownFlag: false });
    this.props.onRangeMouseUp(event, airType, rangeValue);
  };

  render() {
    const { forInitialAirType, language } = this.props;
    const { switchChecked, rangeMouseDownFlag, onAt } = this.state;
    const { handleSwitchChange, onRangeMouseDown, getRangeStep, onRangeMouseUp } = this;
    const rangeStep = getRangeStep();
    return (
      <RangeInputSetter
        airIndexes={airIndexes[language ? language : 'en'][forInitialAirType]}
        onAt={onAt}
        rangeStep={rangeStep}
        switchChecked={switchChecked}
        onRangeMouseDown={onRangeMouseDown}
        onRangeMouseUp={onRangeMouseUp}
        rangeMouseDownFlag={rangeMouseDownFlag}
        onSwitchChange={handleSwitchChange}
      />
    );
  }
}

export default connect(
  ({ core, thermostats }) => ({
    language: core.language,
    initialTriggerEntities: thermostats.initialTriggerEntities,
    changedTriggerEntities: thermostats.changedTriggerEntities
  }),
  () => ({})
)(RangeSetterContainer);



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/RangeSetterContainer.js